import { IQuyetDinhHocVu } from "../../../model/response/xet-hoc-vu/IQuyetDinhHocVu";
import { IQuyetDinhHocVuSinhVien } from "../../../model/response/xet-hoc-vu/IQuyetDinhHocVuSinhVien";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eQuyetDinhHocVuActionsObj = {
    LOAD_BY_DOT_START: 0,
    LOAD_SUCCESS: {} as IQuyetDinhHocVu[],
    LOAD_ERROR: "",

    SHOW_EDIT_MODAL: {} as IQuyetDinhHocVu | undefined,
    CLOSE_EDIT_MODAL: undefined,

    SAVE_START: {} as IQuyetDinhHocVu,
    SAVE_SUCCESS: undefined,
    SAVE_ERROR: "",

    DELETE_START: 0,
    DELETE_SUCCESS: undefined,
    DELETE_ERROR: "",

    SHOW_SINH_VIEN_MODAL: {} as IQuyetDinhHocVu,
    CLOSE_SINH_VIEN_MODAL: undefined,

    LOAD_SINH_VIEN_START: 0,
    LOAD_SINH_VIEN_SUCCESS: {} as IQuyetDinhHocVuSinhVien[],
    LOAD_SINH_VIEN_ERROR: "",

    DONG_BO_KET_QUA_START: 0,
    DONG_BO_KET_QUA_SUCCESS: undefined,
    DONG_BO_KET_QUA_ERROR: "",

    ADD_SINH_VIEN_START: {} as { id_quyet_dinh: number, ids: string[] },
    ADD_SINH_VIEN_SUCCESS: undefined,
    ADD_SINH_VIEN_ERROR: "",

    REMOVE_SINH_VIEN_START: {} as { id_quyet_dinh: number, ids: number[] },
    REMOVE_SINH_VIEN_SUCCESS: undefined,
    REMOVE_SINH_VIEN_ERROR: "",
}

export const eQuyetDinhHocVuActionIds = generateActionTypeIds(eQuyetDinhHocVuActionsObj, "QUYET_DINH_HOC_VU");
export type IQuyetDinhHocVuActionTypes = IGenericActionType<typeof eQuyetDinhHocVuActionsObj, "QUYET_DINH_HOC_VU">;
